<template>
  <div class="py-4 container-fluid">
    <h4 class="text-white">CLIENTES</h4>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-show="vertabla">
              <button
                type="button"
                @click="agregar_cliente()"
                class="btn btn-info btn-sm float-right"
              >
                Agregar
              </button>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="numerocedula"
                      placeholder="Buscar por nombre"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <div class="input-group input-group-merge">
                      <button
                        @click="buscarCedula(numerocedula)"
                        type="button"
                        class="btn btn-info"
                      >
                        Buscar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="datacliente!= ''"
                class="table-responsive"
              >
                <table class="table table-flush" style="overflow: scroll;height: 750px;">
                  <thead class="thead-light">
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center">Documento</th>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">estado</th>
                      <!-- <th class="text-center">editar</th> -->
                    </tr>
                  </thead>
                  <tbody v-for="(cli, index) in datacliente" :key="index">
                    <tr>
                      <td class="text-center">{{ index + 1 }}</td>
                      <td class="text-center">{{ cli.documento }} - {{ cli.numero }}</td>
                      <td class="text-center">{{ cli.pnombre }} {{ cli.papellido }} {{cli.sapellido}}</td>
                      <td class="text-center">
                        <div v-if="cli.estado == 'A'">
                <span class="badge badge-sm bg-gradient-success">Activo</span>
                        </div>
                        <div v-else-if="cli.estado == 'I'">
                <span class="badge badge-sm bg-gradient-danger">Inactivo</span>
                        </div>
                        <div v-else>
                  <span class="badge badge-sm bg-gradient-secondary">Pendiente</span>
                        </div>
                        </td>
                      <!-- <td class="text-center">
                        <a type="button" @click="seleccionarusuario(cli)" class="btn btn-sm btn-vimeo btn-icon-only" style="margin-right: 4px;">
                          <i class="fas fa-edit"></i>
                        </a>
                        <a type="button" @click="actualizarestado(cli.numero)" class="btn btn-sm btn-danger btn-icon-only" style="margin-right: 4px;">
                          <i class="ni ni-ui-04"></i>
                        </a>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Modals agregar usuario -->
            <div v-show="verformulario">
              <h4 class="text-center">{{titulo}} <button
                type="button"
                @click="vertablaclientes()"
                class="btn btn-danger btn-sm float-lg-end"
              >
               <i class="fa fa-arrow-left coloriconos fa-5x"></i>
              </button></h4>
              <br>
              <div class="row">
                <div class="col-md-6">
                  <h6><strong>Tipo Documento</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datosclientes.documento">
                      <option value="" disabled>Seleccionar Tipo documento</option>
                      <option v-for="(item, index) in tiposdocumentos" :value="item.Codigo" :key="index">
                        {{ item.Nombre }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <h6><strong># Documento</strong></h6>
                  <div class="form-group">
                    <input
                      type="number"
                      class="form-control"
                      v-model="datosclientes.numero"
                      placeholder="# documento"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <h6><strong>Primer Nombre</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datosclientes.pnombre"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <h6><strong>Segundo Nombre</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datosclientes.snombre"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <h6><strong>Primer Apellido</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datosclientes.papellido"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <h6><strong>Segundo Apellido</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datosclientes.sapellido"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <h6><strong>Celular</strong></h6>
                  <div class="form-group">
                    <input
                      type="number"
                      placeholder="Regular"
                      v-model="datosclientes.celular"
                      class="form-control"
                    />
                  </div>
                </div>
                 <div class="col-md-6">
                  <h6><strong>Estado</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datosclientes.estado">
                      <option value="">Seleccionar Estado</option>
                      <option value="A">Activo</option>
                      <option value="I">Inactivo</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="text-center">
              <button type="button" class="btn" :class="[colorboton]" 
              v-on:click=" boton == 'Registrar' ? insertarcliente() : actualiza_cliente(datosclientes)">
                  <span>{{ boton }}</span>
                </button>
              </div>
            </div>
            <!-- -------------------------------------------------------------------------------------------------------- -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tiposdocumentos from "../assets/json/tiposdocumentos.json";
import axios from "axios";
export default {
  name: "tables",
  components: {},
  data() {
    return {
      verformulario: false,
      vertabla: true,
      titulo: "",
      boton: "",
      colorboton: "",
      claselargo: "",
      datacliente: "",
      numerocedula: "",
      datosclientes: {
        documento: "",
        numero: "",
      pnombre: "",
      snombre: "",
      papellido: "",
      sapellido:"",
      celular: "",
      estado: ""
  },
      tiposdocumentos:tiposdocumentos,
    };
  },
  created: function () {
  },
  methods: {
    buscarCedula(numerocedula) {
      if (
        numerocedula == "" ||
        numerocedula == undefined ||
        numerocedula == null
      ) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Especificar un nombre o una cedula",
          "info"
        );
      } else if (
        numerocedula != "" ||
        numerocedula != undefined ||
        numerocedula != null
      ) {
        this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
        const tokenpeticion = {
          cedulaonombre: numerocedula,
        };
        axios.post("buscarcliente",tokenpeticion)
          .then((respuesta) => {
            this.$swal.close();
            this.datacliente = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },
    vertablaclientes() {
      this.verformulario = false;
      this.vertabla = true;
    },
    agregar_cliente() {
      this.verformulario = true;
      this.vertabla = false;
      this.titulo = "Agregar Cliente";
      this.boton = "Registrar";
      this.colorboton = "btn-primary";
      this.claselargo = "col-md-3";
      this.datosclientes;
    },
    seleccionarusuario(idcliente) {
      this.verformulario = true;
      this.vertabla = false;
      this.titulo = "Editar Cliente";
      this.boton = "Actualizar";
      this.colorboton = "btn-info";
      this.claselargo = "col-md-4";
      this.datosclientes = idcliente;
    },
    insertarcliente() {
      if (this.datosclientes.documento == "" || this.datosclientes.documento == null || this.datosclientes.documento == undefined ||
      this.datosclientes.numero == "" || this.datosclientes.numero == null || this.datosclientes.numero == undefined ||
      this.datosclientes.pnombre == "" || this.datosclientes.pnombre == null || this.datosclientes.pnombre == undefined ||
      this.datosclientes.papellido == "" || this.datosclientes.papellido == null || this.datosclientes.papellido == undefined ||
      this.datosclientes.celular == "" || this.datosclientes.celular == null || this.datosclientes.celular == undefined ||
      this.datosclientes.estado == "" || this.datosclientes.estado == null || this.datosclientes.estado == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Llenar Todos los campos",
          "info");
      } else {
        this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
        axios.post("registrarcliente",this.datosclientes)
          .then((respuesta) => {
            this.$swal.close()
            if(respuesta.data.codigo == 0){
              this.$swal.fire("Exito", respuesta.data.mensaje, "success")
              this.verformulario = false;
              this.vertabla = true;
              this.datacliente = "";
            }else{
              this.$swal.fire("Info", respuesta.data.mensaje, "error")
            }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },
    actualiza_cliente() {
      if (this.datosclientes.documento == "" || this.datosclientes.documento == null || this.datosclientes.documento == undefined ||
      this.datosclientes.numero == "" || this.datosclientes.numero == null || this.datosclientes.numero == undefined ||
      this.datosclientes.pnombre == "" || this.datosclientes.pnombre == null || this.datosclientes.pnombre == undefined ||
      this.datosclientes.papellido == "" || this.datosclientes.papellido == null || this.datosclientes.papellido == undefined ||
      this.datosclientes.celular == "" || this.datosclientes.celular == null || this.datosclientes.celular == undefined ||
      this.datosclientes.estado == "" || this.datosclientes.estado == null || this.datosclientes.estado == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Llenar Todos los campos",
          "info");
      } else {
         this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
      axios.post("editarcliente",this.datosclientes)
        .then((respuesta) => {
           this.$swal.close()
          if(respuesta.data.codigo == 0){
              this.$swal.fire("Exito", respuesta.data.mensaje, "success")
              this.verformulario = false;
              this.vertabla = true;
              this.datacliente = "";
            }else{
              this.$swal.fire("Info", respuesta.data.mensaje, "error")
            }
        }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },

       actualizarestado(cliente) {
this.$swal.fire({
            title: "Actualizar Estado",
            text: "Esta seguro de Cambiar el estado!",
            icon: "info",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Actualizar",
            cancelButtonColor: '#d33',
             html: `<div class="col-md-12">
                    <label class="form-control-label">Servicio</label>
                   <div class="form-group"> 
                   <select name="estado" id="estado" class="form-select">
                   <option value="">Seleccionar Servicio</option>
                   <option value="A">Activo</option>
                   <option value="I">Inactivo</option>
                    </select>
                    </div>
                    </div>`,
          })
          .then((result) => {
            if (result.isConfirmed) {
      const peticion = {
        cliente:cliente,
        estado: document.getElementsByName('estado')[0].value
      };
       if(peticion.estado == "" || peticion.estado == null || peticion.estado == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Ingrese Una Contraseña",
          "info");
      } else {
      axios.post("actualizarestadocliente",peticion)
        .then((respuesta) => {
          if(respuesta.data.codigo == 0){
              this.$swal.fire("Exito", respuesta.data.mensaje, "success")
              this.verformulario = false;
              this.vertabla = true;
              this.datacliente = "";
            }else{
              this.$swal.fire("Info", respuesta.data.mensaje, "error")
            }
        }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
            }
}});
    },
  },
};
</script>
<style scoped>
.coloriconos{
  color:white;
}
</style>
